import React from 'react';
import classnames from 'classnames';

import NamedLink from '../NamedLink/NamedLink';
import css from './StateCard.module.css';

const StateCard = ({ title, image, routeName, routeTo, routeParams, className }) => {
  return (
    <NamedLink
      className={classnames(css.root, className)}
      name={routeName}
      to={routeTo}
      params={routeParams}
    >
      <div className={css.imageOverlay} />
      <img src={image} alt={title} className={css.image} />
      <div className={css.title}>{title}</div>
    </NamedLink>
  );
};

export default StateCard;
